import { OrderStatusE } from 'enums';

export const getAthleteOrderStatusTranslationKey = (status: OrderStatusE) =>
  status.toLowerCase().replace(' ', '-');
